export default "__VITE_PUBLIC_ASSET__9b2370ca__"